if (!customElements.get('inventory-indicator')) {
  customElements.define(
    'inventory-indicator',
    class InventoryIndicator extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        if (this.isInitialized) return;

        this.isInitialized = true;
        this.addEventListener('click', this.handleToggle);
        this.variantSelect = this.closest('product-info')?.querySelector('[name="id"]');

        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', this.handleVariantChange);
          this.updateInventory(this.variantSelect.value);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleToggle);
        this.variantSelect?.removeEventListener('change', this.handleVariantChange);
        this.abortController?.abort();
        this.isInitialized = false;
      }

      handleToggle(event) {
        const toggle = event.target.closest?.('.inventory-indicator__toggle');
        if (!toggle || !this.contains(toggle)) return;

        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.inventory-indicator__toggle').forEach((openToggle) => {
          openToggle.setAttribute('aria-expanded', 'false');
          openToggle.nextElementSibling.hidden = true;
        });

        if (shouldOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          toggle.nextElementSibling.hidden = false;
        }
      }

      handleVariantChange(event) {
        this.updateInventory(event.target.value);
      }

      async updateInventory(variantId) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const response = await fetch(`https://apollo-dealer-proxy.onrender.com/tbc-stock/${variantId}`, {
            headers: { 'Content-Type': 'application/json' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`Inventory request failed with status ${response.status}`);
          this.updateStockDisplay(await response.json());
        } catch (error) {
          if (error.name !== 'AbortError') console.error('Inventory API error:', error);
        }
      }

      updateStockDisplay(data) {
        if (!Array.isArray(data)) return;

        const locationElements = {
          Mornington: this.querySelector('[data-inventory-status="mornington"]'),
          Rye: this.querySelector('[data-inventory-status="rye"]'),
          'Dandenong Factory Outlet': this.querySelector('[data-inventory-status="dandenong"]'),
          'Dandenong Click & Collect': this.querySelector('[data-inventory-status="warehouse"]'),
        };

        Object.values(locationElements).forEach((element) => {
          if (element) element.innerHTML = this.stockStatusMarkup(null);
        });

        data.forEach((entry) => {
          const element = locationElements[entry.location];
          if (element) element.innerHTML = this.stockStatusMarkup(entry.status);
        });
      }

      stockStatusMarkup(status) {
        let label = 'In stock';
        let color = '62, 214, 96';

        if (status === null || status === '' || status === '-') {
          label = 'Not stocked';
          color = '200, 200, 200';
        } else if (status === 'Out of stock') {
          label = 'Out of stock';
          color = '200, 200, 200';
        } else if (status === 'Low stock') {
          label = 'Low stock';
          color = '238, 148, 65';
        }

        return `<svg width="15" height="15" aria-hidden="true">
          <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(${color}, 0.3)"/>
          <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(${color})"/>
        </svg> <span>${label}</span>`;
      }
    }
  );
}
